import { styled } from '@uhg-abyss/web/tools/styled';
import { Heading } from '@uhg-abyss/web/ui/Heading';

export const ButtonStyles = {
  marginTop: '16px',
  fontWeight: '600',
  lineHeight: '20px',
  height: '42px',
  padding: ' 8px 16px 8px 24px',
  'abyss-button-content-container': {
    height: '20px',
  },
};

export const IconStyles = {
  'abyss-icon-symbol': {
    marginLeft: '4px',
  },
};

export const CommonlySearchedStyled = styled('div', {
  backgroundColor: 'white',
  marginTop: '8px',
});

export const Content = styled('p', {
  fontSize: '14.22px',
  lineHeight: '16px',
  color: '$core.color.neutral.80',
  fontWeight: '$medium',
  width: 'calc(100% - 500px)',
});

export const NullPageContainerStyled = styled('div', {
  backgroundColor: '#FBFCFE',
});

const mobilePadding = {
  '@media (max-width: 744px)': {
    padding: '16px 0',
  },
};

const nullPagePadding = {
  padding: '24px 0',
  borderBottom: '1px solid #E5E5E6',
  ...mobilePadding,
};

export const NullResultSectionStyled = styled('div', {
  backgroundColor: 'white',
  borderTop: '1px solid #E5E5E6',
  marginBottom: '8px',
  ...nullPagePadding,
});

export const SubHeader = styled(Heading, {
  marginTop: '16px',
  marginBottom: '16px',
});

export const Wrapper = styled('div', {
  maxWidth: '1200px',
  marginLeft: 'auto',
  marginRight: 'auto',
  '@media (max-width: 1248px)': {
    marginLeft: '24px',
    marginRight: '24px',
  },
  '@media (max-width: 744px)': {
    marginLeft: '16px',
    marginRight: '16px',
  },
});
